import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "carousel" }

import { Swiper, SwiperSlide } from "swiper/vue";
import ImageComponents from "../image/ImageComponent.vue";
import VideoComponent from "../video/videoComponent.vue";
import { Autoplay, Pagination } from "swiper";
import { toRefs } from "vue";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";


export default /*#__PURE__*/_defineComponent({
  __name: 'CarouselComponent',
  props: {
    array: {}
  },
  setup(__props: any) {

const props = __props;

const getUrl = (path: string) => require("@/assets/" + path);

const data = toRefs(props);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_unref(Swiper), {
      class: "carousel",
      height: 100,
      "centered-slides": true,
      loop: true,
      modules: [_unref(Autoplay), _unref(Pagination)],
      "slides-per-view": 1,
      speed: 750,
      pagination: true,
      "allow-touch-move": false,
      autoplay: { disableOnInteraction: false }
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).array.value, (imgSrc, i) => {
          return (_openBlock(), _createBlock(_unref(SwiperSlide), {
            "data-swiper-autoplay": imgSrc.includes('webp') ? 3000 : 5000,
            key: i
          }, {
            default: _withCtx(() => [
              (imgSrc.includes('webp') || imgSrc.includes('png'))
                ? (_openBlock(), _createBlock(ImageComponents, {
                    key: 0,
                    class: _normalizeClass('swiper-image'),
                    src: getUrl(imgSrc),
                    description: imgSrc
                  }, null, 8, ["src", "description"]))
                : _createCommentVNode("", true),
              (imgSrc.includes('mp4'))
                ? (_openBlock(), _createBlock(VideoComponent, {
                    key: 1,
                    src: getUrl(imgSrc)
                  }, null, 8, ["src"]))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["data-swiper-autoplay"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modules"])
  ]))
}
}

})